export const formatUpdateDate = (originalDate: string) => {
    const splited = originalDate.split('T');
    const date = new Date(splited[0]).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
    const time = splited[1].split('.')[0];
    return `${date} às ${time}`;
};
